<template>
  <v-card class="mt-5">
    <v-layout class="px-4 py-4 wrap">
      <v-flex>
        <h3 class="xs12">How Full It Was During The Latest Cleanups</h3>
        <div class="xs12 body-2">Does not contain missed work area records.</div>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      loader-height="2"
      :footer-props="{'items-per-page-options': [10, 20]}"
      class="elevation-0 table-org"
      :header-props="{ 'sort-icon': 'arrow_downward' }"
      mobile-breakpoint="100"
    >
      <template v-slot:item="{item}">
        <tr class="items-body-row">
          <td>
            <span v-if="!no_data.includes(item.job_date)">{{ item.job_date }}</span>  
            <em v-else class="grey--text">No data</em>
          </td>
          <td>
            <div v-if="!no_data.includes(item.full_status_id) && fullStatuses.some(i => i.id === item.full_status_id)" style="min-width: 80px;">
              <v-progress-linear
                :value="fullStatuses.find(i => i.id === item.full_status_id).value"
                :color="fullStatuses.find(i => i.id === item.full_status_id).color"
                background-color="#ddd"
                height="25"
              >
                <template>
                  <span>{{ fullStatuses.find(i => i.id === item.full_status_id).name }}</span>
                </template>
              </v-progress-linear>
            </div>  
            <em v-else class="grey--text">No data</em>
          </td>
          <td>
            <span v-if="!no_data.includes(item.repair_answer)">{{ item.repair_answer }}</span>  
            <em v-else class="grey--text">No data</em>
          </td>
          <td>
            <span v-if="!no_data.includes(item.missed) && Boolean(Number(item.missed))" class="text-uppercase" :class="`work-area-how-full-report-status-missed`">MISSED</span>
            <span v-else-if="!no_data.includes(item.skip_reason) || [0, '0'].includes(item.skip_reason_id)" class="text-uppercase" :class="`work-area-how-full-report-status-skipped`">SKIPPED</span>
            <span v-else class="text-uppercase" :class="`work-area-how-full-report-status-completed`">COMPLETED</span>
          </td>
          <td>
            <span v-if="!no_data.includes(item.skip_reason)">{{ item.skip_reason }}</span>
            <span v-else-if="[0, '0'].includes(item.skip_reason_id)">Job was skipped</span>
            <em v-else class="grey--text">No data</em>
          </td>
          <td>
            <v-layout v-if="!no_data.includes(item.employee_id)" style="margin-left: -14px;">
              <v-menu bottom right d-inline-flex>
                <template v-slot:activator="{ on }">
                  <v-btn class="ma-0" v-on="on" icon>
                    <v-icon color="#999">more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="pa-0">
                  <v-list-item
                    @click="$router.push(`/staff/${item.employee_id}/show`)"
                  >
                    <v-flex class="body-1">
                      <v-icon class="mr-2" color="primary" size="18px">visibility</v-icon>
                      View Field Tech Details
                    </v-flex>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-layout class="wrap align-center">
                <v-flex v-if="staff.some(i => i.id === item.employee_id)">
                  {{ staff.find(i => i.id === item.employee_id).name }}
                </v-flex>
                <v-flex v-else>
                  <em class="grey--text">No data</em>
                </v-flex>
              </v-layout>
            </v-layout>
            <em v-else class="grey--text">No data</em>
          </td>
          <td>
            <span v-if="!no_data.includes(item.comment)">{{ item.comment }}</span>  
            <em v-else class="grey--text">No data</em>
          </td>
        </tr>
      </template>
      <template
        slot="no-data"
        v-if="error_code == 404 || error_code == 500"
      >
        <v-btn color="primary" @click="addResServReport()">Reset</v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import ApiService from "@/common/api.service";
import { mapActions } from "vuex"

export default {
  name: "HowFullReport",
  data: () => ({
    no_data: [null, "", undefined, "null"],
    headers: [
      { 
        text: "Date", 
        value: "job_date", 
        align: "left",
        sortable: false,
      },
      {
        text: "How full it was",
        value: "full_status_id",
        align: "left",
        sortable: false,
      },
      {
        text: "Repair Needed",
        value: "repair_answer",
        align: "left",
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        align: "left",
        sortable: false,
      },
      {
        text: "Skip Reason",
        value: "skip_reason",
        align: "left",
        sortable: false,
      },
      {
        text: "Field Tech",
        value: "employee_id",
        align: "left",
        sortable: false,
      },
      {
        text: "Comment",
        value: "comment",
        align: "left",
        sortable: false,
      }
    ],
    items: [],
    options: {},
    totalItems: 0,
    draw: 0,
    tableData: {
      draw: 0,
      length: 10,
      page: 0,
      column: 0,
      dir: "asc"
    },
    loading: false,
    workAreaTypes: [
      { name: 'Pet Waste Station', slug: 'pet_station' },
      { name: 'Trash Can', slug: 'trash_can' },
      { name: 'Service Area', slug: 'service_area' },
    ],
    fullStatuses: [],
    fullStatusColors: [
      {id: 1, name: "Empty", value: 0, color: 'grey lighten-1'},
      {id: 2, name: "1/4", value: 25, color: 'green lighten-1'},
      {id: 3, name: "1/2", value: 50, color: 'yellow lighten-1'},
      {id: 4, name: "3/4", value: 75, color: 'amber lighten-1'},
      {id: 5, name: "Full", value: 100, color: 'orange lighten-1'},
      {id: 6, name: "Overflow", value: 100, color: 'red lighten-1'}
    ],
    error_code: "",
    staff: [],
    staffLoading: false,
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong..."
  }),
  mounted() {
    this.initialize()
    this.getStaffList()
  },
  watch: {
    options: {
      handler() {
        if (this.draw !== this.tableData.draw) {
          this.initialize();
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['vEmit']),
    initialize(setPage = null) {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      this.tableData.column = 0;
      if (
        !this.no_data.includes(sortBy) &&
        !this.no_data.includes(sortBy[0]) &&
        this.headers.some(i => i.value === sortBy[0] && i.sortable !== false)
      ) {
        this.tableData.column = this.headers.find(
          i => i.value === sortBy[0]
        ).sort_column;
      }
      this.tableData.dir = !this.no_data.includes(sortDesc) && sortDesc[0] === true ? "asc" : "desc";

      this.tableData.length = itemsPerPage;

      this.tableData.page = page;
      this.tableData.search = this.search;
      this.tableData.draw++;
      this.draw = this.tableData.draw;

      this.tableData.work_area_id = this.$route.params.id

      ApiService.get("/inventory_tracking/work_area_activity_log/how_full_report", this.tableData)
        .then(response => {
          this.draw++
          this.items = response.data.how_full_report.data
          this.totalItems = response.data.how_full_report.total
          let fullStatuses = response.data.full_statuses
          fullStatuses.forEach(i => {
            if (this.fullStatusColors.some(color => color.name === i.name)) {
              let color = this.fullStatusColors.find(color => color.name === i.name)
              i.value = color.value
              i.color = color.color
            }
          })
          this.fullStatuses = fullStatuses
          if (setPage) { this.options.page = setPage }
          this.loading = false;
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    getStaffList() {
      this.staffLoading = true
      ApiService.get("/employee_select_list")
        .then(res => {
          this.staff = res.data.staff
          this.staffLoading = false
        })
        .catch(err => {
          console.log(err)
          this.staffLoading = false
        });
    }
  }
};
</script>
<style>

.completed-jobs-reports-wrap .header-search-single {
  padding-bottom: 20px;
}

.completed-jobs-reports-wrap .clear-filters {
  text-transform: none;
  color: #00838F;
  cursor: pointer;
  text-decoration: underline;
  font-size: 13px;
}
.work-area-how-full-report-status-missed {
  color: red;
}
.work-area-how-full-report-status-completed,
.work-area-how-full-report-status-started {
  color: forestgreen;
}
.work-area-how-full-report-status-pending {
  color: #9e9e9e;
}
.work-area-how-full-report-status-skipped {
  color: #2196f3;
}
.work-area-how-full-report-status-dispatched {
  color: orange;
}


</style>
